import React from 'react';

export const Logo = ({ animation }) => {
  return (
    <div className="page-header-logo">
      <i className="fas fa-balance-scale" style={{ animation: animation }}></i>
    </div>
  );
};
